import { render, staticRenderFns } from "./DashboardNavbar_market.vue?vue&type=template&id=edfb3a32&scoped=true&"
import script from "./DashboardNavbar_market.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar_market.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavbar_market.vue?vue&type=style&index=0&id=edfb3a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfb3a32",
  null
  
)

export default component.exports